// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"e2d51b44","498":"084016fa","513":"4030e994","787":"370dc34e"}[chunkId] + ".chunk.js";
};